export const ACTIONS:any = {
	DELETE: 'delete',
	MARK_AS_ACCEPT: 'accept',
	MARK_AS_APPROVE: 'approve',
	MARK_AS_REJECT: 'reject',
	MARK_AS_REJECTED: 'rejected',
	MARK_AS_CANCELED: 'canceled',
	CREATE_LOGISTIQ: 'create_logistiq',
	MARK_AS_ACCEPT_SELECTED:'accept_selected'
}